export const deepMerge = <T extends object>(target: T, source: object): T => {
  const src = source as Record<string, unknown>;
  const tgt = target as Record<string, unknown>;
  for (const key in src) {
    const sourceVal = src[key];
    if (
      sourceVal &&
      typeof sourceVal === 'object' &&
      !Array.isArray(sourceVal) &&
      !(sourceVal instanceof Date)
    ) {
      if (!tgt[key] || typeof tgt[key] !== 'object') {
        tgt[key] = {};
      }
      deepMerge(tgt[key] as Record<string, unknown>, sourceVal as Record<string, unknown>);
    } else {
      tgt[key] = sourceVal;
    }
  }
  return target;
};
